<p>{{ 'dashboard.query.unbalancedquantity.remove.label' | translate: { count: elements.length } }}</p>
